import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import { dynamicDataAttribute, toOneString, formatPrice } from 'helpers/utils'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import { A } from 'components/common/Link/Link'
import Image from 'components/common/Image'

const Tire = ({
  seePriceTitle,
  navigateToQuoteHandler,
  brandImageUrl,
  brandName,
  description,
  unitPrice,
  listPrice,
  mainImageUrl,
  name,
  qty,
  size,
  staggeredPrefix,
  strikeOff,
  hasActiveVehicle,
  storePhoneNumber,
  isShowPrice,
  showStoreLocatorModal,
  formattedStorePhoneNumber,
  showSelectLocationLinkInsteadOfPrice
}) =>
  <Wrapper { ...dynamicDataAttribute('tire-wrapper', toOneString(staggeredPrefix)) }>
    {
      mainImageUrl &&
      <LeftBlock>
        <TireImage
          data-at-tire-image
          src={ `${mainImageUrl}?$BOT-AddedToQuoteModal-Tire-Desktop-w144$` }
          mobileSrc={ `${mainImageUrl}?$BOT-AddedToQuoteModal-Tire-Mobile-w136$` } />
      </LeftBlock>
    }
    <RightBlock>
      {
        brandImageUrl &&
        <LogoWrapper>
          <Logo data-at-brand-logo src={ brandImageUrl } alt={ brandName } />
        </LogoWrapper>
      }
      <Name data-at-modal-add-to-quote-name>{ name }</Name>
      <Size data-at-modal-add-to-quote-size>
        { staggeredPrefix &&
          <StaggeredPrefix data-at-staggered-prefix>{ staggeredPrefix }</StaggeredPrefix>
        }
        { size }
      </Size>
      {
        hasActiveVehicle &&
          <React.Fragment>
            {
              showSelectLocationLinkInsteadOfPrice ?
                <A
                  bolder
                  prevent
                  data-at-select-store-link
                  handler={ showStoreLocatorModal }>
                  Select Store For Price
                </A> :
                isShowPrice ?
                  <React.Fragment>
                    <Price data-at-price>{ formatPrice(listPrice) }</Price>
                    <Price small>/each</Price>
                  </React.Fragment>
                  :
                  <A bolder prevent data-at-see-price-link handler={ navigateToQuoteHandler }>{ seePriceTitle }</A>
            }
          </React.Fragment>
      }
      <QuantityText data-at-quantity>{ `Qty: ${qty}` }</QuantityText>
    </RightBlock>
  </Wrapper>

Tire.propTypes = {
  brandImageUrl: PropTypes.string,
  brandName: PropTypes.string,
  description: PropTypes.string,
  formattedStorePhoneNumber: PropTypes.string,
  hasActiveVehicle: PropTypes.bool,
  isShowPrice: PropTypes.bool,
  listPrice: PropTypes.number,
  mainImageUrl: PropTypes.string,
  name: PropTypes.string,
  navigateToQuoteHandler: PropTypes.func,
  qty: PropTypes.number,
  seePriceTitle: PropTypes.string,
  showSelectLocationLinkInsteadOfPrice: PropTypes.bool,
  showStoreLocatorModal: PropTypes.func,
  size: PropTypes.string,
  staggeredPrefix: PropTypes.string,
  storePhoneNumber: PropTypes.string,
  strikeOff: PropTypes.bool,
  unitPrice: PropTypes.number
}

export default Tire

const Wrapper = styled.div`
  ${Mixin.responsive('padding', '0 0 0 168px', '0 0 10px 0')}
  ${Mixin.clearFix()}
`

const LeftBlock = styled.div`
  float: left;
  position: relative;
  ${Mixin.responsive('height', '144px', '136px')}
  ${Mixin.responsive('margin', '0 0 0 -168px', '0 5px 0 0')};
`

const RightBlock = styled.div`
  float: left;
  ${Media.mobile`
    width: 50%;
  `}
  ${Media.desktop`
    margin-bottom: 20px;
  `}
`

const Size = styled.div`
  margin-bottom: 11px;
  color: ${Theme.colors.black_new};
  text-transform: uppercase;
  ${Mixin.font.GothamBook(14)}
`

const StaggeredPrefix = styled.span`
  ${Mixin.font.GothamBold()}
  font-size: 0.8em;
  margin-right: 8px;
`

const Price = styled.span`
  margin-right: 10px;
  color: ${Theme.colors.sub_grey};
  ${Mixin.font.GothamBold(14)}
  ${props => props.small && css`
    margin-right: 5px;
    color: ${Theme.colors.caption_grey};
    ${Mixin.font.GothamBook(14)}
  `}
  ${props => props.old && css`
    text-decoration: line-through;
  `}
  ${Media.mobile`
    &:last-child {
      display: block;
    }
  `}
`

const QuantityText = styled.div`
  color: ${Theme.colors.black_new};
  ${Mixin.font.GothamBook(14)}
`

const LogoWrapper = styled.div`
  position: relative;
  width: 120px;
  ${Mixin.responsive('height', '30px', '20px')}
`

const Logo = styled(Image)`
  width: 100%;
  height: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`

const Name = styled.div`
  text-align: left;
  color: ${Theme.colors.black_new};
  ${Mixin.font.GothamBold(18)}
  ${Media.mobile`
    margin-top: 8px;
  `}
`

const TireImage = styled(Image)`
  width: 125px;
  height: auto;
`
